import { KYDBlockData } from "@common/interfaces/KYDCampaign";
import { KYDScope } from "@common/interfaces/ICognito";

export type SuggestedAutomationRecipe = {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  available: boolean;
  buildPayload: () => {
    name: string;
    status?: "DRAFT" | "ACTIVE" | "PAUSED" | "ARCHIVED";
    trigger: Record<string, unknown>;
    steps: Array<Record<string, unknown>>;
    description?: string;
    tags?: string[];
  };
};

export const canShowSuggestedAutomations = (permissions: KYDScope[] = []) =>
  permissions.includes("platforms/write");

const welcomeEmailBlocks = (): KYDBlockData[] => [
  {
    id: `blk_${Math.random().toString(36).slice(2, 9)}`,
    type: "image",
    src: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?auto=format&fit=crop&w=1800&q=80",
  } as KYDBlockData,
  {
    id: `blk_${Math.random().toString(36).slice(2, 9)}`,
    type: "textBody",
    body: {
      type: "doc",
      content: [
        {
          type: "heading",
          attrs: {
            level: 1,
            textAlign: "center",
            color: "#B33A2C",
          },
          content: [
            {
              type: "text",
              text: "See you at the show!",
            },
          ],
        },
        {
          type: "paragraph",
          attrs: {
            textAlign: "center",
          },
          content: [
            {
              type: "text",
              text: "All of us at {{org_name}} look forward to seeing you soon!",
              marks: [{ type: "bold" }],
            },
          ],
        },
        {
          type: "paragraph",
          attrs: {
            textAlign: "center",
          },
          content: [
            {
              type: "text",
              text: "Thanks for supporting independent live music - now sit back and get ready for the show.",
              marks: [{ type: "bold" }],
            },
          ],
        },
      ],
    },
  } as KYDBlockData,
  {
    id: `blk_${Math.random().toString(36).slice(2, 9)}`,
    type: "button",
    title: "Check Out Our Full Concert Calendar",
    link: "{{org_link}}",
    attrs: {
      backgroundColor: "#B33A2C",
      textColor: "#FFFFFF",
    },
  } as KYDBlockData,
  {
    id: `blk_${Math.random().toString(36).slice(2, 9)}`,
    type: "divider",
  } as KYDBlockData,
];

export const SUGGESTED_AUTOMATIONS: SuggestedAutomationRecipe[] = [
  {
    id: "first-time-welcome",
    title: "First Time Welcome",
    subtitle: "After First Purchase",
    available: true,
    description:
      "After the customer's first completed checkout in your organization, wait 1h and send a welcome email.",
    buildPayload: () => ({
      name: "First Time Welcome",
      description:
        "After the customer's first completed checkout in your organization, wait 1h and send a welcome email.",
      status: "PAUSED",
      trigger: {
        type: "EVENT",
        event_type: "checkout.completed",
        event_detail: {
          first_time_for_org: [true],
        },
      },
      steps: [
        {
          id: "step_welcome_email",
          name: "Welcome email",
          description:
            "Send a welcome email 1 hour after the customer's first completed checkout.",
          type: "EMAIL",
          subject: "Welcome to the community, {{first_name}}",
          blocks: welcomeEmailBlocks(),
          delay_minutes: 60,
        },
      ],
      tags: ["suggested", "welcome"],
    }),
  },
  // {
  //   id: "post-event-follow-up",
  //   title: "Post-Event Follow Up",
  //   subtitle: "Keep Fans in the Loop",
  //   available: false,
  //   description:
  //     "After ticket check-in, wait 12h and send an email. Includes 1-day cool-off per contact.",
  //   buildPayload: () => ({
  //     name: "Keep Fans in the Loop",
  //     status: "ACTIVE",
  //     trigger: {
  //       type: "EVENT",
  //       event_type: "event.ticket.checkedin",
  //       re_enrollment_cooldown_minutes: 60 * 24,
  //     },
  //     steps: [
  //       {
  //         id: "step_keep_fans_email",
  //         name: "Post-event thank you",
  //         description: "Send a follow-up email 12 hours after ticket check-in.",
  //         type: "EMAIL",
  //         subject: "Thanks for joining us, {{first_name}}",
  //         blocks: defaultEmailBlocks(
  //           "See you at the next one!",
  //           "We loved having you at {{event_name}}. Stay tuned for what comes next."
  //         ),
  //         delay_minutes: 60 * 12,
  //       },
  //     ],
  //     tags: ["suggested", "post-event"],
  //   }),
  // },
  // {
  //   id: "abandoned-cart-emails",
  //   title: "Abandoned Cart Emails",
  //   subtitle: "Recover Lost Sales",
  //   available: false,
  //   description:
  //     "Automatically follow up with fans who added a ticket to their cart but didn't complete their purchase.",
  //   buildPayload: () => ({
  //     name: "Abandoned Cart Emails",
  //     description:
  //       "Automatically follow up with fans who added a ticket to their cart but didn't complete their purchase.",
  //     status: "ACTIVE",
  //     trigger: {
  //       type: "EVENT",
  //       event_type: "event.cart.expired",
  //     },
  //     steps: [
  //       {
  //         id: "step_check_eligibility_2h",
  //         name: "Eligibility check (2 hours)",
  //         description:
  //           "After 2 hours, verify the fan is still eligible for cart abandonment outreach.",
  //         type: "CHOICE",
  //         delay_minutes: 120,
  //         condition: {
  //           fact: "is_cart_abandonment_eligible",
  //           equals: true,
  //         },
  //         next_step_id_true: "step_email_2h",
  //         next_step_id_false: "exit",
  //       },
  //       {
  //         id: "step_email_2h",
  //         name: "2 hour reminder",
  //         description: "Send the first abandoned cart reminder email.",
  //         type: "EMAIL",
  //         subject: "Still thinking about {{event_name}}?",
  //         blocks: defaultEmailBlocks(
  //           "Your tickets are waiting",
  //           "You were close to checking out for {{event_name}}. Grab your tickets before it sells out."
  //         ),
  //         delay_minutes: 0,
  //       },
  //       {
  //         id: "step_check_eligibility_2d",
  //         name: "Eligibility check (2 days)",
  //         description:
  //           "After 2 days, verify the fan is still eligible before sending another reminder.",
  //         type: "CHOICE",
  //         delay_minutes: 60 * 24 * 2,
  //         condition: {
  //           fact: "is_cart_abandonment_eligible",
  //           equals: true,
  //         },
  //         next_step_id_true: "step_email_2d",
  //         next_step_id_false: "exit",
  //       },
  //       {
  //         id: "step_email_2d",
  //         name: "2 day reminder",
  //         description: "Send the second abandoned cart reminder email.",
  //         type: "EMAIL",
  //         subject: "Don’t miss out on {{event_name}}",
  //         blocks: defaultEmailBlocks(
  //           "Still interested?",
  //           "Tickets are still available for {{event_name}}. Secure your spot while they last."
  //         ),
  //         delay_minutes: 0,
  //       },
  //       {
  //         id: "step_check_eligibility_1w",
  //         name: "Eligibility check (1 week)",
  //         description:
  //           "After 1 week, verify the fan is still eligible before sending the final reminder.",
  //         type: "CHOICE",
  //         delay_minutes: 60 * 24 * 5,
  //         condition: {
  //           fact: "is_cart_abandonment_eligible",
  //           equals: true,
  //         },
  //         next_step_id_true: "step_email_1w",
  //         next_step_id_false: "exit",
  //       },
  //       {
  //         id: "step_email_1w",
  //         name: "1 week reminder",
  //         description: "Send the final abandoned cart reminder email.",
  //         type: "EMAIL",
  //         subject: "Final reminder for {{event_name}}",
  //         blocks: defaultEmailBlocks(
  //           "Last chance",
  //           "This is your final reminder for {{event_name}}. We would love to see you there."
  //         ),
  //         delay_minutes: 0,
  //       },
  //     ],
  //     tags: ["suggested", "cart-abandonment"],
  //   }),
  // },
];
